document.addEventListener("DOMContentLoaded", function () {
  initReadMoreContainers();
  cleanCartBasedOnUserType();
});
function initReadMoreContainers() {
  document.querySelectorAll('.read-more__container').forEach(container => {
    const content = container.querySelector('.read-more__content');
    const button = container.querySelector('.read-more__btn');
    
    if (!content || !button) return;
    
    const spanReadMore = button.querySelector('.read-more__text');
    const spanReadLess = button.querySelector('.read-less__text');
    
    if (!spanReadMore || !spanReadLess) return;
    
    const maxVisibleLines = parseInt(content.dataset.chunkLines, 10) || 10;
    
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    
    const maxHeight = maxVisibleLines * lineHeight;
    
    const contentHeight = content.scrollHeight;
    
    let visibleMarginBottom = 0;
    let accumulatedHeight = 0;
    
    content.childNodes.forEach(child => {
      if (child.nodeType === 1) { 
        const childHeight = child.offsetHeight;
        const childMarginBottom = parseFloat(getComputedStyle(child).marginBottom) || 0;
        
        accumulatedHeight += childHeight;
        
        if (accumulatedHeight <= maxHeight) {
          visibleMarginBottom += childMarginBottom;
        }
      }
    });
    
    const adjustedMaxHeight = maxHeight + visibleMarginBottom;
    
    const totalLines = Math.ceil(contentHeight / lineHeight);
    
    if (totalLines > maxVisibleLines) {
      button.style.display = 'inline-block';
      
      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        
        if (isExpanded) {
          content.style.maxHeight = `${contentHeight}px`;
          spanReadMore.style.display = 'none';
          spanReadLess.style.display = 'inline';
        } else {
          content.style.maxHeight = `${adjustedMaxHeight}px`;
          spanReadMore.style.display = 'inline';
          spanReadLess.style.display = 'none';
        }
      });
      
      content.style.maxHeight = `${adjustedMaxHeight}px`;
    } else {
      button.style.display = 'none';
    }
  });
}


function cleanCartBasedOnUserType() {
  const esEmpleado = document.body.classList.contains('es-empleado');
  let seEliminoAlgo = false;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const promesas = [];

      cart.items.forEach(item => {
        const vendor = item.vendor;
        const key = item.key;

        const debeEliminar =
          (esEmpleado && vendor !== 'EMP Catalog') ||
          (!esEmpleado && vendor !== 'B2C Catalog');

        if (debeEliminar) {
          seEliminoAlgo = true;

          const promesa = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: 0
            })
          });

          promesas.push(promesa);
        }
      });

      if (seEliminoAlgo) {
        Promise.all(promesas).then(() => {
          location.reload();
        });
      }
    });
}

// Ejecutar
cleanCartBasedOnUserType();
